import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { ListDisplaySize } from '@/contexts/order-guide-settings-context';
import { Maybe } from '@/types';
import { OrderableItemListItemImage } from '@/components/orders/orderable-item-list-item-image';
import { Text, View } from 'react-native';
import { useItemDisplayOptions } from '@/contexts/new-order-context';

interface Props {
  displayName: string;
  externalID: string;
  packUnit: string;
  photoURLs?: Maybe<string[]>;
}

export const LostItemSupportInfo: React.FC<Props> = ({
  displayName,
  externalID,
  packUnit,
  photoURLs,
}) => {
  const [styles] = useStyles();
  const { hidePlaceholderImages } = useItemDisplayOptions();
  const altText = [displayName, externalID].filter(Boolean).join('-');

  return (
    <View style={styles.listItemContainer}>
      <OrderableItemListItemImage
        alt={altText}
        hidePlaceholderImages={hidePlaceholderImages}
        imageURLs={photoURLs ?? []}
        listDisplaySize={ListDisplaySize.Small}
        style={styles.imagePreview}
      />
      <View style={styles.variantPackDetails}>
        <Text
          numberOfLines={1}
          style={[TYPOGRAPHY.listTitle, FONTS.primarySemiBold, styles.header]}
        >
          {displayName}
        </Text>
        <Text
          numberOfLines={1}
          style={[FONTS.primary, TYPOGRAPHY.small, styles.packUnit]}
        >
          {externalID}
          {externalID && packUnit ? ' • ' : null}
          {packUnit}
        </Text>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  header: {
    fontSize: 14,
    lineHeight: 21,
  },
  imagePreview: {
    borderColor: theme.colors.imageBorder,
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
  },
  listItemContainer: {
    borderColor: theme.sk.color.border.primary,
    borderRadius: 8,
    borderWidth: 1,
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 8,
  },
  packUnit: {
    color: theme.sk.color.text.tertiary,
    lineHeight: 21,
    textTransform: 'capitalize',
  },
  variantPackDetails: {
    flex: 1,
    marginHorizontal: 8,
  },
}));
